import { Loader, Modal, Typography } from '@trackman/web-shared-components';

type Props = {
  isLoading: boolean;
  title: string;
  message: string;
};

const LoadingModal = ({ isLoading, title, message }: Props) => {
  return (
    <Modal
      title={title}
      open={isLoading}
      onClose={() => {}}
      componentsProps={{ headerBaseCloseIcon: { icon: null } }}
      isHeaderSeparatorHidden={true}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
        <Loader size='large' />
        <Typography component='div'>{message}</Typography>
      </div>
    </Modal>
  );
};

export default LoadingModal;
